var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownloadGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_6470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.85742 11.3333V12.6666C2.85742 13.0202 2.9979 13.3593 3.24795 13.6094C3.49799 13.8594 3.83713 13.9999 4.19076 13.9999H12.1908C12.5444 13.9999 12.8835 13.8594 13.1336 13.6094C13.3836 13.3593 13.5241 13.0202 13.5241 12.6666V11.3333",
    stroke: "#9BA7B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85742 7.33325L8.19076 10.6666L11.5241 7.33325",
    stroke: "#9BA7B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19067 2.66675V10.6667",
    stroke: "#9BA7B6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_6470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.190674)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadGrey);
export default __webpack_public_path__ + "static/media/Icon_Download_Grey.625ed95472f220c4aa5d7f4d59e64d0f.svg";
export { ForwardRef as ReactComponent };